import { gql } from '@apollo/client';

export default gql`
  {
    assessmentsCollection(
      where: { reviewStatus: "Accepted" }
      limit: 8
      order: userRating_DESC
    ) {
      items {
        name
        slug
      }
    }
  }
`;
